import axios from 'axios';
import mime from 'mime/lite';

export const getResponseType = (type: any) => {
  if (/xml|html/.test(type)) {
    return 'document';
  }
  if (/json/.test(type)) {
    return 'json';
  }
  return 'text';
};

export const setupRequestInterceptor = async (onError: (reason: string) => void) => {
  axios.interceptors.response.use(undefined, async (onErrorResponse) => {
    console.log(onErrorResponse);

    let status;
    const response = onErrorResponse.response;
    if (response && response.status) {
      status = response.status;
    }
    const config = onErrorResponse.config;
    let failedUrl;
    if (config) {
      failedUrl = config.url;
    }

    // eslint-disable-next-line default-case
    switch (status) {
      case 403:
        /*
          File missing! However, assume that it's not a "core" file missing (eg. book page) as the book should
          have been tested before, we ignore the issue and continue.

          Consider reporting to datadog, or start processing logs from bunny to identify these issues! Or
          notifying the user if it's staging and/or the "testplayer".
         */
        break;
      case 401:
        onError('error_no_access');
        break;
      case 404:
        // eslint-disable-next-line no-case-declarations
        const ignoredUrlsRegex =
          /bookmarks|annotations|trace|events|readlogs|exercises|META-INF\/com\.apple\.ibooks\.display-options\.xml/;
        if (!ignoredUrlsRegex.test(failedUrl)) {
          onError('error_not_found');
        }
        break;
      case 502:
        onError('error_in_book_unknown');
        break;
    }
    return Promise.reject(onErrorResponse);
  });
};

export const sendRequest = async (url: string, type: string) => {
  if (!url) {
    /*
     Sometimes epubjs sends undefined resource url
     https://ilt-education.sentry.io/issues/130067720/
     */
    throw new Error('Empty book player resource url.');
  }

  const _url = new URL(url) as URL;

  const responseType = getResponseType(type || mime.getType(_url.pathname));

  const response = await axios.get(_url.toString(), {
    responseType,
    // @ts-ignore
    noAuth: true, // Custom Axios behavior
  });

  return response.data;
};

// eslint-disable-next-line consistent-return
export const sendReadLogs = async (readLogsData: any) => {
  const url = `${process.env.VUE_APP_READLOG_BACKEND_BASE_URL}/readlogs`;
  try {
    await axios.post(url.toString(), readLogsData);
  } catch (error: any) {
    if (error.response) {
      return error.response;
    }
  }
};
